/** English of the game data (ADR 0069, step 3), keyed by the exact French text. See `index.ts`. */
export const DATA_ITEMS: Readonly<Record<string, string>> = {
  '+{v} DPS': '+{v} DPS',
  '+{v} Vie': '+{v} Health',
  '+{v} Défense': '+{v} Defense',
  '+{v} % de chance de critique': '+{v}% critical chance',
  '+{v} % de dégâts critiques': '+{v}% critical damage',
  '-{v} % de recharge des sorts': '-{v}% spell cooldown',
  '+{v} énergie par seconde': '+{v} energy per second',
  '{v} % des dégâts rendus en vie': '{v}% of damage returned as Health',
  '+{v} % de dégâts aux boss et élites': '+{v}% damage to bosses and elites',
  'Tonique des champs': 'Meadow Tonic',
  'Potion des champs': 'Meadow Potion',
  'Tonique de sylve': 'Sylvan Tonic',
  'Potion de sylve': 'Sylvan Potion',
  'Tonique des marais': 'Marsh Tonic',
  'Potion des marais': 'Marsh Potion',
  'Tonique des sables': 'Sand Tonic',
  'Potion des sables': 'Sand Potion',
  'Tonique de givre': 'Frost Tonic',
  'Potion de givre': 'Frost Potion',
  'Houlette ferrée': 'Iron-Shod Crook',
  'Bouclier d’osier': 'Wicker Shield',
  'Chapeau de paille': 'Straw Hat',
  'Pelisse de berger': "Shepherd's Coat",
  'Gants de berger': "Shepherd's Gloves",
  'Guêtres de berger': "Shepherd's Gaiters",
  'Coutelas du chasseur': "Hunter's Cutlass",
  'Bouclier du chasseur': "Hunter's Shield",
  'Capuche du chasseur': "Hunter's Hood",
  'Brigandine du chasseur': "Hunter's Brigandine",
  'Gants du chasseur': "Hunter's Gloves",
  'Bottes du chasseur': "Hunter's Boots",
  'Lame d’écailles': 'Scale Blade',
  'Bouclier d’écailles': 'Scale Shield',
  'Casque d’écailles': 'Scale Helm',
  'Cuirasse d’écailles': 'Scale Cuirass',
  'Gantelets d’écailles': 'Scale Gauntlets',
  'Bottes d’écailles': 'Scale Boots',
  'Khépesh du pharaon': "Pharaoh's Khopesh",
  'Bouclier du pharaon': "Pharaoh's Shield",
  'Némès du pharaon': "Pharaoh's Nemes",
  'Pectoral du pharaon': "Pharaoh's Pectoral",
  'Brassards du pharaon': "Pharaoh's Bracers",
  'Sandales du pharaon': "Pharaoh's Sandals",
  'Épée de givre': 'Frost Sword',
  'Bouclier de givre': 'Frost Shield',
  'Casque de givre': 'Frost Helm',
  'Plastron de givre': 'Frost Breastplate',
  'Gantelets de givre': 'Frost Gauntlets',
  'Bottes de givre': 'Frost Boots',
  'Champ Maudit': 'Cursed Field',
  'Coup de faux': 'Scythe Sweep',
  'Nuée de corbeaux': 'Crow Swarm',
  'Clairière de la Lune': 'Moonlit Glade',
  Bond: 'Leap',
  Hurlement: 'Howl',
  'Bourbier du Troll': "Troll's Mire",
  'Fracas de massue': 'Club Smash',
  'Onde de boue': 'Mud Wave',
  'Temple du Chacal': 'Jackal Temple',
  'Rayon du soleil': 'Sunbeam',
  'Tempête de sable': 'Sandstorm',
  'Trône de Givre': 'Frost Throne',
  'Pics de glace': 'Ice Spikes',
  Grêle: 'Hail',
  'Onde glaciale': 'Glacial Wave',
  Guerrier: 'Warrior',
  Archer: 'Archer',
  Mage: 'Mage',
  'Chien de feu': 'Fire Hound',
  'Renard de lumière': 'Light Fox',
  Glitch: 'Glitch',
  'Renardeau de Sylvebois': 'Sylvebois Fox Cub',
  'Petit caïman de Brumevase': 'Little Brumevase Caiman',
  'Cheval de feu': 'Fire Horse',
  'Cheval de Havrebourg': 'Havrebourg Horse',
  'Chameau de Sablerouge': 'Sablerouge Camel',
  Pégase: 'Pegasus',
  'Drake de Shefira': "Shefira's Drake",
  'Chat noir': 'Black Cat',
  Slime: 'Slime',
  'Mini-golem': 'Mini Golem',
  'Mini-yéti': 'Mini Yeti',
  'Loup de guerre': 'War Wolf',
  Bleu: 'Blue',
  Vert: 'Green',
  Brun: 'Brown',
  Gris: 'Gray',
  Rouge: 'Red',
  Doré: 'Golden',
  Noir: 'Black',
  Châtain: 'Chestnut',
  Blond: 'Blond',
  Roux: 'Ginger',
  Cendré: 'Ash',
  'Cheveux courts': 'Short Hair',
  'Crâne rasé': 'Shaved Head',
  'Cheveux longs': 'Long Hair',
  Masculin: 'Masculine',
  Féminin: 'Feminine',
  'Queue de cheval': 'Ponytail',
  Tresse: 'Braid',
  Carré: 'Bob',
  Boucles: 'Curls',
  'Épée courte': 'Short Sword',
  'Arc court': 'Short Bow',
  'Baguette en bois': 'Wooden Wand',
  'Épée du dragon': 'Dragon Sword',
  'Heaume du dragon': 'Dragon Helm',
  'Plastron du dragon': 'Dragon Breastplate',
  'Gantelets du dragon': 'Dragon Gauntlets',
  'Bottes du dragon': 'Dragon Boots',
  'Bouclier du dragon': 'Dragon Shield',
  'Épée de flamme': 'Flame Sword',
  'Heaume de flamme': 'Flame Helm',
  'Cuirasse de flamme': 'Flame Cuirass',
  'Gantelets de flamme': 'Flame Gauntlets',
  'Bottes de flamme': 'Flame Boots',
  'Bouclier de flamme': 'Flame Shield',
  'Ailes de glace': 'Ice Wings',
  'Ailes de flamme': 'Flame Wings',
  'Ailes du dragon': 'Dragon Wings',
  'Ailes de papillon': 'Butterfly Wings',
  'Ailes d’ange': 'Angel Wings',
  'Ailes de chauve-souris': 'Bat Wings',
  'Épée de cristal': 'Crystal Sword',
  'Lance-étendard': 'Banner Spear',
  'Poireau de combat': 'Battle Leek',
  'Traînée de braises': 'Ember Trail',
  'Traînée de givre': 'Frost Trail',
  'Traînée de pétales': 'Petal Trail',
  'Traînée de feuilles': 'Leaf Trail',
  'Traînée d’aurore': 'Aurora Trail',
  'Traînée de cendres': 'Ash Trail',
  'Traînée de paille': 'Straw Trail',
  'Traînée de lucioles': 'Firefly Trail',
  'Traînée de spores': 'Spore Trail',
  'Traînée de sable': 'Sand Trail',
  'Traînée de neige': 'Snow Trail',
  'Tête de citrouille': 'Pumpkin Head',
  'Haillons de l’épouvantail': "Scarecrow's Rags",
  'Gants de l’épouvantail': "Scarecrow's Gloves",
  'Bottes de l’épouvantail': "Scarecrow's Boots",
  'Faux de l’épouvantail': "Scarecrow's Scythe",
  'Lanterne des moissons': 'Harvest Lantern',
  'Corbeau de minuit': 'Midnight Crow',
  'Épée de l’Aurore': 'Aurora Sword',
  'Heaume de l’Aurore': 'Aurora Helm',
  'Cuirasse de l’Aurore': 'Aurora Cuirass',
  'Gantelets de l’Aurore': 'Aurora Gauntlets',
  'Bottes de l’Aurore': 'Aurora Boots',
  'Bouclier de l’Aurore': 'Aurora Shield',
  'Ailes de l’Aurore': 'Aurora Wings',
  'Renard polaire de l’Aurore': 'Aurora Polar Fox',
  'Crâne de wyrm': 'Wyrm Skull',
  'Cuirasse d’ossements': 'Bone Cuirass',
  'Gantelets d’ossements': 'Bone Gauntlets',
  'Bottes d’ossements': 'Bone Boots',
  'Croc de wyrm': 'Wyrm Fang',
  'Écaille de wyrm': 'Wyrm Scale',
  Griffon: 'Griffon',
  'Faucon de chasse': 'Hunting Falcon',
  'Cimeterre du djinn': "Djinn's Scimitar",
  'Turban du djinn': "Djinn's Turban",
  'Soieries du djinn': "Djinn's Silks",
  'Brassards du djinn': "Djinn's Bracers",
  'Babouches du djinn': "Djinn's Slippers",
  'Lampe du djinn': "Djinn's Lamp",
  'Tapis volant': 'Flying Carpet',
  'Massue-totem du chaman': "Shaman's Totem Club",
  'Coiffe du chaman': "Shaman's Headdress",
  'Manteau du chaman': "Shaman's Mantle",
  'Brassards d’os du chaman': "Shaman's Bone Bracers",
  'Bottes du chaman': "Shaman's Boots",
  'Bouclier de peau du chaman': "Shaman's Hide Shield",
  'Harfang des neiges': 'Snowy Owl',
  'Lame des Cinq Terres': 'Blade of the Five Lands',
  'Lame sylvestre': 'Sylvan Blade',
  'Couronne sylvestre': 'Sylvan Crown',
  'Cuirasse sylvestre': 'Sylvan Cuirass',
  'Gantelets sylvestres': 'Sylvan Gauntlets',
  'Bottes sylvestres': 'Sylvan Boots',
  'Bouclier de racines': 'Rootwoven Shield',
  'Cerf sylvestre': 'Sylvan Stag',
  'Bâton des tourbières': 'Bogland Staff',
  'Capuche des tourbières': 'Bogland Hood',
  'Robe des tourbières': 'Bogland Robe',
  'Gants des tourbières': 'Bogland Gloves',
  'Bottes des tourbières': 'Bogland Boots',
  'Lanterne des tourbières': 'Bogland Lantern',
  'Grenouille-lanterne': 'Lantern Frog',
  'Épée du dragon (apparence)': 'Dragon Sword (Cosmetic)',
  'Heaume du dragon (apparence)': 'Dragon Helm (Cosmetic)',
  'Plastron du dragon (apparence)': 'Dragon Breastplate (Cosmetic)',
  'Gantelets du dragon (apparence)': 'Dragon Gauntlets (Cosmetic)',
  'Bottes du dragon (apparence)': 'Dragon Boots (Cosmetic)',
  'Bouclier du dragon (apparence)': 'Dragon Shield (Cosmetic)',
  'Bouclier en bois': 'Wooden Shield',
  'Carquois en cuir': 'Leather Quiver',
  'Grimoire usé': 'Worn Grimoire',
  'Petite potion de vie': 'Small Health Potion',
  'Potion de vie': 'Health Potion',
  Pain: 'Bread',
  'Appât pestilentiel': 'Plague Bait',
  'Queue de rat': 'Rat Tail',
  'Peau de rat': 'Rat Pelt',
  'Défense de sanglier': 'Boar Tusk',
  'Cuir de sanglier': 'Boar Hide',
  'Peau de loup': 'Wolf Pelt',
  'Oreille de gobelin': 'Goblin Ear',
  'Bave de crapaud': 'Toad Slime',
  'Écaille de lézard': 'Lizard Scale',
  'Croc de hyène': 'Hyena Fang',
  'Bandelette de momie': 'Mummy Wrapping',
  "Fourrure d'ours": 'Bear Fur',
  'Corne de yéti': 'Yeti Horn',
  'Queue de renard': 'Fox Tail',
  'Écorce de sylvain': 'Treant Bark',
  'Dent de caïman': 'Caiman Tooth',
  'Dard de scorpion': 'Scorpion Stinger',
  'Écaille de braise': 'Ember Scale',
  'Croc de givre': 'Frost Fang',
  'Cœur gelé': 'Frozen Heart',
  'Empennage gobelin': 'Goblin Fletching',
  'Lueur de feu follet': 'Wisp Glow',
  'Venin de cobra': 'Cobra Venom',
  'Plume de harpie': 'Harpy Feather',
  'Épée en bois': 'Wooden Sword',
  'Rondache en bois': 'Wooden Buckler',
  'Casque d’écorce': 'Bark Helm',
  'Plastron d’écorce': 'Bark Breastplate',
  'Gantelets en bois': 'Wooden Gauntlets',
  'Sabots en bois': 'Wooden Clogs',
  'Lame de Croc-d’Argent': 'Silverfang Blade',
  'Écu du Roi des Tourbières': "Bog King's Shield",
  'Sceptre d’Ounas-Rê': "Ounas-Rê's Scepter",
  'Épée d’Eirik': "Eirik's Sword",
  Silex: 'Flint',
  'Minerai de cuivre': 'Copper Ore',
  'Relique des Anciens': 'Elder Relic',
  'Résine ambrée': 'Amber Resin',
  'Lingot de fer': 'Iron Ingot',
  'Cœur de sylve': 'Sylvan Heart',
  'Argile des marais': 'Bog Clay',
  'Perle de vase': 'Mire Pearl',
  'Œil du marais': 'Marsh Eye',
  'Scarabée d’or': 'Gold Scarab',
  'Sceau du pharaon': "Pharaoh's Seal",
  'Éclat de givre': 'Frost Shard',
  'Cristal de glace': 'Ice Crystal',
  'Cœur de glacier': 'Glacier Heart',
  'Écaille de Shefira': "Shefira's Scale",
  'Quartier de viande fumée': 'Smoked Meat Haunch',
  'Bourse de verroterie': 'Pouch of Glass Beads',
  'Sifflet d’argent': 'Silver Whistle',
  'Ver de tourbe': 'Peat Worm',
  'Idole d’écailles': 'Scale Idol',
  'Lotus noir': 'Black Lotus',
  'Carcasse faisandée': 'Rotting Carcass',
  'Encens funéraire': 'Funeral Incense',
  'Cartouche royal': 'Royal Cartouche',
  'Rayon de miel givré': 'Frosted Honeycomb',
  'Corne des hurlements': 'Horn of Howls',
  'Orbe de tempête': 'Storm Orb',
  Rat: 'Rat',
  Renard: 'Fox',
  Sanglier: 'Boar',
  Loup: 'Wolf',
  Gobelin: 'Goblin',
  Sylvain: 'Treant',
  'Archer gobelin': 'Goblin Archer',
  'Crapaud géant': 'Giant Toad',
  'Feu follet': "Will-o'-Wisp",
  'Homme-lézard': 'Lizardman',
  Hyène: 'Hyena',
  'Scorpion géant': 'Giant Scorpion',
  'Cobra cracheur': 'Spitting Cobra',
  Momie: 'Mummy',
  'Salamandre de braise': 'Ember Salamander',
  'Loup des glaces': 'Ice Wolf',
  'Ours blanc': 'Polar Bear',
  'Harpie des neiges': 'Snow Harpy',
  'Revenant du givre': 'Frost Revenant',
  Yéti: 'Yeti',
  'Rat pesteux': 'Plague Rat',
  'Sanglier balafré': 'Scarred Boar',
  'Loup cendré': 'Ash Wolf',
  'Chef gobelin': 'Goblin Chief',
  'Crapaud venimeux': 'Venom Toad',
  'Chaman lézard': 'Lizard Shaman',
  'Roi des Tourbières': 'Bog King',
  'Hyène galeuse': 'Mangy Hyena',
  'Momie maudite': 'Cursed Mummy',
  'Pharaon oublié': 'Forgotten Pharaoh',
  'Ours des glaces': 'Ice Bear',
  'Yéti hurleur': 'Howling Yeti',
  'Vieux Blizzard': 'Old Blizzard',
  'Grand Épouvantail': 'Great Scarecrow',
  'Troll des Tourbières': 'Bog Troll',
  'Chacal d’Or': 'Golden Jackal',
  'Géant de Givre': 'Frost Giant',
  'Pillard gobelin': 'Goblin Raider',
  'Chef de guerre gobelin': 'Goblin Warlord',
  'Groin-de-Fer géant': 'Giant Ironsnout',
  'Croc-d’Argent géant': 'Giant Silverfang',
  'Roi des Tourbières géant': 'Giant Bog King',
  'Pharaon oublié géant': 'Giant Forgotten Pharaoh',
  'Vieux Blizzard géant': 'Giant Old Blizzard',
  'Renard calciné': 'Charred Fox',
  'Sylvain fou': 'Maddened Treant',
  'Caïman affolé': 'Frenzied Caiman',
  'Loup de minuit': 'Midnight Wolf',
  'Revenant des bois': 'Wood Revenant',
  'Noyé des tourbières': 'Bog Drowned',
  'Feu des dunes': 'Dune Wisp',
  'Gisant des glaces': 'Ice Sleeper',
  Roussette: 'Russet',
  'la vieille renarde des blés': 'the old vixen of the wheat',
  'Écorce-Noire': 'Blackbark',
  'le sylvain errant': 'the wandering treant',
  'Vieille-Mousse': 'Old Mossback',
  'le caïman ancestral': 'the ancestral caiman',
  'Dard-Rouge': 'Red Stinger',
  'le scorpion-roi': 'the scorpion king',
  'Plume-de-Givre': 'Frostplume',
  'la harpie solitaire': 'the lone harpy',
  'Queue de Roussette': 'Russet’s Brush',
  'Cœur d’Écorce-Noire': 'Heart of Blackbark',
  'Dent de Vieille-Mousse': 'Old Mossback’s Tooth',
  'Dard de Dard-Rouge': 'Red Stinger’s Sting',
  'Rémige de Plume-de-Givre': 'Frostplume’s Quill',
  'Brise-Clôture': 'Fence-Breaker',
  'Un sanglier énorme défonce les clôtures au pied de la Butte aux Vents. Les fermiers de Havrebourg paient qui l’abattra.':
    "A huge boar is smashing the fences below Windy Knoll. Havrebourg's farmers will pay whoever brings it down.",
  'Croque-Poules': 'Hen-Snatcher',
  'Un renard rusé vide les poulaillers depuis des semaines. On l’a vu rôder près de la Tour de Guet.':
    'A cunning fox has been emptying the henhouses for weeks. It was seen prowling near the Watchtower.',
  'Croc-Gris': 'Grey-Fang',
  'Un loup plus grand que les autres attaque les bûcherons près du Roc aux Loups. Sylvebois offre une prime pour sa peau.':
    'A wolf bigger than the rest attacks woodcutters near Wolf Rock. Sylvebois offers a bounty for its pelt.',
  'Cœur-de-Ronce': 'Bramble-Heart',
  'Un sylvain furieux barre le sentier du Mont Moussu et écrase tout ce qui passe. Il faut l’abattre.':
    'A furious treant blocks the path up Mossy Mount and crushes everything that passes. It must be felled.',
  'Gobe-Tout': 'Gulp-All',
  'Un crapaud géant avale les filets des pêcheurs au Tertre Noyé, et parfois les pêcheurs avec.':
    "A giant toad swallows the fishermen's nets at the Drowned Mound, and sometimes the fishermen too.",
  'Écaille-Tombe': 'Grave-Scale',
  'Un homme-lézard pille les tombes du Cimetière Englouti. Brumevase veut qu’on le chasse pour de bon.':
    'A lizardman is robbing the graves of the Sunken Graveyard. Brumevase wants it driven off for good.',
  'Ricane-Sang': 'Blood-Cackle',
  'Une hyène énorme attaque les caravanes près de la Grotte des Hyènes. Les chameliers paient bien.':
    'A huge hyena attacks the caravans near Hyena Cave. The camel drivers pay well.',
  'Gardien sans nom': 'Nameless Warden',
  'Une momie s’est réveillée au pied de l’Obélisque Oublié. Elle frappe tous ceux qui approchent.':
    'A mummy has woken at the foot of the Forgotten Obelisk. It strikes anyone who comes near.',
  'Terreur-Blanche': 'White Terror',
  'Un ours blanc affamé est sorti de la Caverne de l’Ours. Les chasseurs de Givrecime n’osent plus y aller.':
    "A starving polar bear has come out of Bear's Cavern. Givrecime's hunters no longer dare go there.",
  'Hurle-Cristal': 'Crystal-Howler',
  'Un loup des glaces hurle chaque nuit autour des Cristaux du Givre. La voyante voudrait dormir.':
    'An ice wolf howls every night around the Frost Crystals. The seer would like to sleep.',
  'Ronge-Grange': 'Barn-Gnawer',
  'Un rat gros comme un chien a fait son nid dans la grange de la Ferme calcinée. Le fermier Gautier dit qu’il lui mange le peu que le feu a laissé.':
    "A rat the size of a dog has nested in the barn of the Charred Farm. Farmer Gautier says it's eating the little the fire left him.",
  'Vole-Baies': 'Berry-Thief',
  'Un rat énorme vole les baies que l’ermite Aubépin laisse au Cercle des Anciens. Aubépin dit que ses pierres sont très contrariées.':
    'A huge rat steals the berries the hermit Aubépin leaves at the Circle of Elders. Aubépin says his stones are very upset about it.',
  'Mord-Sabot': 'Hoof-Biter',
  'Un grand renard mord les chevaux aux pattes au pied du Mont Clair. Le palefrenier Gaspard ne laisse plus sortir ses bêtes, et elles boudent.':
    "A big fox bites the horses' legs at the foot of Clear Mount. Gaspard the stablemaster won't let his animals out anymore, and they're sulking.",
  'Souche-Fumante': 'Smoking-Stump',
  'Un sylvain à moitié brûlé tourne en rond dans la Saignée et assomme tout ce qui bouge. La druidesse Mélisande dit qu’il est de très mauvaise humeur, et on la croit.':
    "A half-burnt treant wanders in circles in the Scar and flattens anything that moves. Mélisande the druid says it's in a very bad mood, and we believe her.",
  'Vole-Hache': 'Axe-Thief',
  'Un gobelin a volé la hache d’Anselme le bûcheron et coupe du bois avec, près du Camp des Gobelins. Anselme dit surtout qu’il la tient mal.':
    "A goblin stole Anselme the woodcutter's axe and is chopping wood with it near the Goblin Camp. What bothers Anselme most is that it holds it wrong.",
  'Tire-Tout': 'Shoot-All',
  'Un archer gobelin perché sur le Pic des Ramures tire sur tout ce qui fait du bruit. Corvin le trappeur trouvait l’idée bonne, jusqu’à la flèche dans son chapeau.':
    'A goblin archer perched on Antler Peak shoots at anything that makes noise. Corvin the trapper liked the idea, until the arrow in his hat.',
  'Croque-Barque': 'Boat-Cruncher',
  'Un caïman long comme une barque dort dans les Ruines Noyées et mord tout ce qui passe. Le passeur Ansgar refuse d’y emmener la sienne tant qu’il est là.':
    "A caiman as long as a boat sleeps in the Drowned Ruins and bites whatever goes by. Ansgar the ferryman won't take his own boat there while it's around.",
  'Lanterne-Folle': 'Mad-Lantern',
  'Un feu follet tourne sans arrêt au-dessus de l’Empreinte et attire les curieux dans la vase. La traqueuse Nella dit qu’il lui brouille toutes ses pistes.':
    "A will-o'-the-wisp circles over the Clawprint day and night and lures the curious into the mud. Nella the tracker says it muddles all her trails.",
  'Mèche-Morte': 'Grave-Wick',
  'Un feu follet se promène toutes les nuits entre les tombes du Cimetière Englouti. La fossoyeuse Guénola dit que ses morts n’arrivent plus à dormir avec cette lumière.':
    "A will-o'-the-wisp wanders between the graves of the Sunken Graveyard every night. Guénola the gravedigger says her dead can't sleep with that light on.",
  'Pince-Chameau': 'Camel-Pincher',
  'Un scorpion géant s’est caché sous le Relais des chameliers et pince les chameaux aux pattes. Idris dit que Safran ne veut plus s’agenouiller pour personne.':
    "A giant scorpion is hiding under the Camel Drivers' Post and pinches the camels' legs. Idris says Safran won't kneel for anyone anymore.",
  'Brûle-Tentes': 'Tent-Burner',
  'Une salamandre de braise descend de l’Aiguille de Braise la nuit et met le feu aux tentes. Le forgeron de Sablerouge voudrait sa peau, vu le prix du charbon.':
    "An ember salamander comes down from the Ember Spire at night and sets the tents on fire. Sablerouge's blacksmith would like its hide, given the price of coal.",
  'Crache-Venin': 'Venom-Spitter',
  'Un cobra cracheur vise les yeux des voyageurs sur la Plaine de verre. Kassim a juré par tous les puits de payer qui l’en débarrassera.':
    "A spitting cobra aims for travellers' eyes on the Glass Plain. Kassim has sworn by every well to pay whoever rids him of it.",
  'Grand-Pied': 'Big-Foot',
  'Un yéti boit la bière de l’éclaireur Torvald sur la Crête du Givre. Torvald jure qu’il n’en reste plus une goutte, et que ce n’est pas lui.':
    "A yeti is drinking Torvald the scout's beer up on the Frost Ridge. Torvald swears there's not a drop left, and that it wasn't him.",
  'Bec-de-Glace': 'Ice-Beak',
  'Une harpie des neiges a fait son nid au bord de la Brèche et vole tout ce qui brille. Le forgeron de Givrecime y a perdu son meilleur marteau.':
    "A snow harpy has nested at the edge of the Breach and steals everything that shines. Givrecime's blacksmith lost his best hammer there.",
  'Chasse-Ours': 'Bear-Chaser',
  'Un revenant du givre s’est installé au fond de la Caverne de l’Ours, et même l’ours n’a pas voulu rester. La chasseuse Sigrun dit qu’elle irait bien, mais pas aujourd’hui.':
    "A frost revenant has settled at the back of Bear's Cavern, and even the bear didn't want to stay. Sigrun the huntress says she'd happily go, just not today.",
  Villageoise: 'Villager',
  Fermier: 'Farmer',
  Garde: 'Guard',
  Forgeron: 'Blacksmith',
  'Graveur de runes': 'Runesmith',
  Marchand: 'Merchant',
  Colporteur: 'Peddler',
  Voyageuse: 'Traveller',
  Fondeur: 'Smelter',
  Alchimiste: 'Alchemist',
  'Hôtel des ventes': 'Auction House',
  Coffre: 'Chest',
  'Avis de recherche': 'Wanted Board',
  'Ser Givrecoeur': 'Ser Givrecoeur',
  Frimas: 'Rime',
  'Capitaine Aldric': 'Captain Aldric',
  'Ermite Aubépin': 'Hermit Aubépin',
  'Guetteuse Maëlle': 'Lookout Maëlle',
  'Garde-forestière Ysolde': 'Forest Warden Ysolde',
  Cerf: 'Deer',
  Cheval: 'Horse',
  'Palefrenier Gaspard': 'Stablemaster Gaspard',
  Chameau: 'Camel',
  'Chamelier Idris': 'Camel Driver Idris',
  Sentinelle: 'Sentry',
  'Fermier Gautier': 'Farmer Gautier',
  'Bûcheron Anselme': 'Woodcutter Anselme',
  'Druidesse Mélisande': 'Druid Mélisande',
  'Trappeur Corvin': 'Trapper Corvin',
  Tobie: 'Tobie',
  'Doyenne Ombeline': 'Elder Ombeline',
  'Passeur Ansgar': 'Ferryman Ansgar',
  'Fossoyeuse Guénola': 'Gravedigger Guénola',
  'Érudit Théophane': 'Scholar Théophane',
  'Traqueuse Nella': 'Tracker Nella',
  'Maître Kassim': 'Master Kassim',
  'Traqueuse Zahra': 'Tracker Zahra',
  'Scribe Néfer': 'Scribe Néfer',
  'Prêtresse Méret': 'Priestess Méret',
  'Jarl Haldor': 'Jarl Haldor',
  'Skalde Runa': 'Skald Runa',
  'Voyante Eira': 'Seer Eira',
  'Chasseuse Sigrun': 'Huntress Sigrun',
  'Éclaireur Torvald': 'Scout Torvald',
  'Vieil Ulfar': 'Old Ulfar',
  Claire: 'Light',
  Dorée: 'Tan',
  Brune: 'Brown',
  Foncée: 'Dark',
  'Frappe puissante': 'Power Strike',
  'Un coup appuyé sur ta cible : deux fois tes dégâts.':
    'A heavy blow on your target: twice your damage.',
  'Tu reprends ton souffle : un quart de ta vie revient.':
    'You catch your breath: a quarter of your Health comes back.',
  Tourbillon: 'Whirlwind',
  'Tu tournoies : tes dégâts à chaque ennemi autour de toi.':
    'You spin: your damage to every enemy around you.',
  Charge: 'Charge',
  "Tu bondis sur ta cible jusqu'à 6 cases, la frappes lourdement et l'étourdis trois secondes.":
    'You leap at your target up to 6 tiles away, strike it hard and stun it for three seconds.',
  Entaille: 'Rend',
  'Une plaie ouverte : ta cible saigne pendant 6 secondes.':
    'An open wound: your target bleeds for 6 seconds.',
  'Mur de bouclier': 'Shield Wall',
  'Tu te couvres : 40 % de dégâts en moins pendant 5 secondes.':
    'You take cover: 40% less damage for 5 seconds.',
  'Coup de bouclier': 'Shield Bash',
  "Tu assommes ta cible deux secondes. Un boss ne s'étourdit pas, mais son attaque annoncée est retardée.":
    "You stun your target for two seconds. A boss can't be stunned, but its announced attack is delayed.",
  Provocation: 'Taunt',
  "Les ennemis à 3 cases s'en prennent à toi pendant 4 secondes. Un boss n'y cède pas.":
    "Enemies within 3 tiles turn on you for 4 seconds. A boss won't give in.",
  'Onde sismique': 'Seismic Wave',
  'Tu frappes le sol : une onde sur 7 cases droit sur ta cible (devant toi sans cible), qui frappe et ralentit tous les ennemis sur son passage.':
    'You strike the ground: a wave 7 tiles long straight at your target (ahead of you without one), hitting and slowing every enemy in its path.',
  Rage: 'Rage',
  'Tu paies un dixième de ta vie : 40 % de DPS en plus pendant 8 secondes.':
    'You pay a tenth of your Health: 40% more DPS for 8 seconds.',
  Exécution: 'Execute',
  'Tes dégâts, mais quatre fois tes dégâts si ta cible a moins d’un quart de sa vie.':
    'Your damage, but four times your damage if your target is below a quarter of its Health.',
  'Colère du titan': "Titan's Wrath",
  'Tu frappes la terre de toutes tes forces : trois fois tes dégâts à 3 cases autour de toi, qui étourdissent.':
    'You strike the earth with all your might: three times your damage to every enemy within 3 tiles, stunning them.',
};
